<template>
<div class="container list">
  <b-btn v-if="authenticated" variant="success" class="float-right" @click="showadd">Tilføj</b-btn>
  <AddItem ref="addItem" />
  <ProductList :data="products" :fields="fields">
    <template slot="header">
      <h2>{{ category.charAt(0).toUpperCase() + category.slice(1) }}</h2>
    </template>
  </ProductList>
</div>
</template>

<script>
import {
  db
} from '../config/firebase';
import AddItem from '@/components/product/Add'
import ProductList from '@/components/product/List'

export default {
  name: 'List',
  components: {
    AddItem,
    ProductList
  },
  props: {
    category: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      fields: [{
          key: 'group',
          label: 'Gruppe'
        }, {
          key: 'type',
          label: 'Type'
        }, {
          key: 'price',
          label: 'Pris',
          formatter: value => {
            return `${parseFloat(value).toLocaleString('da')},00 kr`
          }
        },
        {
          key: 'actions',
          label: '',
        }
      ]
    }
  },
  computed: {
    authenticated() {
      return this.$store.state.authenticated;
    }
  },
  watch: {
    category: function () {
      if (this.$firebaseRefs['products']) {
        this.$unbind('products')
      }
      this.$bindAsArray('products', db.ref('products').orderByChild("category").equalTo(this.category))
    }
  },
  firebase: function () {
    return {
      products: db.ref('products').orderByChild("category").equalTo(this.category)
    }
  },
  methods: {
    showadd() {
      this.$refs.addItem.show()
    }
  }
}
</script>

<style scoped>
.list {
  background-color: #ffffff;
  margin: 100px 0px 100px 0px;
  padding-top: 10px;
  border-radius: 5px;
}
</style>
